import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCrefazClt } from "@/app/contexts/CrefazCltContext";
import { useCrefazCltAuthorization } from "@/app/hooks/useCrefazCltAuthorization";

export default function useAuthorizationModal() {
  const { customerData, preTransaction, setPreTransaction } = useCrefazClt();
  const navigate = useNavigate();

  const authorization = useCrefazCltAuthorization(preTransaction?.id, {
    initialStatus: preTransaction?.status,
    initialSmsSent: preTransaction?.autorizacaoEnviada,
  });

  const { status } = authorization;

  useEffect(() => {
    if (status && status !== preTransaction?.status) {
      setPreTransaction({ status });
    }
  }, [status, preTransaction?.status, setPreTransaction]);

  const handleSimulate = () => {
    if (!preTransaction?.id) return;

    navigate(`/transacoes/crefaz-clt/${preTransaction.id}`);
  };

  return {
    ...authorization,
    customerData,
    observation: authorization.observation,
    handleSimulate,
  };
}
